/* TH-XS&NCE launch, 2569-10-08. One owner per event; legacy code remains at its source. */
(() => {
  'use strict';
  const config = window.nceXsGa4Config;
  if (!config || window.nceXsGa4) return;
  const mapping = {
    'T520-ST-IB-EN': ['OpenFit-Air2', 'Truewireless', 'T520', 'Standard', 'Ice Blue'],
    'T520-ST-WT-EN': ['OpenFit-Air2', 'Truewireless', 'T520', 'Standard', 'White'],
    'T520-ST-BK-EN': ['OpenFit-Air2', 'Truewireless', 'T520', 'Standard', 'Black'],
    'S610-ST-IB-EN': ['OpenRun-Air2', 'Sports', 'S610', 'Standard', 'Ice Blue'],
    'S610-ST-BK-EN': ['OpenRun-Air2', 'Sports', 'S610', 'Standard', 'Black'],
    'S611-MN-BK-EN': ['OpenRun-Air2', 'Sports', 'S611', 'Mini', 'Black']
  };
  // Extend, never replace, the shared lookup used by navigation/cart/comparison tracking.
  if (typeof product_handle_map !== 'undefined' && typeof product_handle_valueMap !== 'undefined') {
    Object.entries(mapping).forEach(([sku, fields]) => {
      product_handle_map.add(sku);
      product_handle_valueMap[sku] = fields.slice(0, 4);
    });
  }
  const sourceKey = 'th_nce_xs_ga4_source';
  const money = cents => Math.round(Number(cents || 0)) / 100;
  const text = element => (element?.textContent || '').trim();
  function send(name, parameters) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event_parameters: null });
    window.dataLayer.push({ event: 'ga4Event', event_name: name, event_parameters: parameters });
  }
  function item(variant, list, index = 1, quantity = 1) {
    const fields = mapping[variant.sku] || (typeof product_handle_valueMap !== 'undefined' && product_handle_valueMap[variant.sku]);
    if (!variant.sku || !fields) return null;
    return {
      item_id: variant.sku, item_name: fields[0], item_variant: fields[1],
      item_category: fields[2], item_category2: fields[3],
      item_category3: fields[4] || variant.color || variant.option1 || '',
      item_brand: 'SHOKZ', item_list_id: typeof list === 'string' ? list : list.id,
      item_list_name: typeof list === 'string' ? list : list.name,
      index: Number(index), quantity: Number(quantity), currency: 'THB',
      price: money(variant.price),
      discount: money(Math.max(0, Number(variant.compare_at_price || 0) - Number(variant.price)))
    };
  }
  function ecommerce(name, productItem, button) {
    if (!productItem) return;
    const parameters = {
      item_list_id: productItem.item_list_id, item_list_name: productItem.item_list_name,
      currency: 'THB', value: Math.round(productItem.price * productItem.quantity * 100) / 100,
      items: [productItem]
    };
    if (button) parameters.button_name = button;
    send(name, parameters);
  }
  function normalizeList(list) {
    const id = typeof list === 'string' ? list.trim() : typeof list?.id === 'string' ? list.id.trim() : '';
    const name = typeof list === 'string' ? list.trim() : typeof list?.name === 'string' ? list.name.trim() : '';
    return id || name ? { id: id || name, name: name || id } : null;
  }
  function remember(handle, list) {
    handle = normalizeHandle(handle);
    list = normalizeList(list);
    if (!['openfit-air-2', 'openrun-air-2'].includes(handle) || !list) return;
    try { sessionStorage.setItem(sourceKey, JSON.stringify({ handle, list, time: Date.now() })); } catch (_) { /* Storage may be disabled. */ }
  }
  function consumeSource() {
    try {
      const source = JSON.parse(sessionStorage.getItem(sourceKey) || 'null');
      sessionStorage.removeItem(sourceKey);
      return normalizeHandle(source?.handle) === normalizeHandle(config.product?.handle) && Date.now() - source.time < 30 * 60 * 1000 ? source.list : '';
    } catch (_) { return ''; }
  }
  function normalizeHandle(handle) {
    if (handle === 'openfit-air2') return 'openfit-air-2';
    if (handle === 'openrun-air2') return 'openrun-air-2';
    return handle || '';
  }
  function handleFromLink(link) {
    try { return normalizeHandle(new URL(link.href, location.href).pathname.match(/\/products\/([^/]+)/)?.[1] || ''); }
    catch (_) { return ''; }
  }
  function selectedVariant() {
    const variants = config.product?.variants || [];
    const id = document.querySelector('.product-right [name="id"]')?.value;
    // Sold-out options in the existing form have no value; their text is not a variant ID.
    return variants.find(variant => String(variant.id) === String(id))
      || variants.find(variant => String(variant.id) === String(config.selectedVariant));
  }
  let viewList = normalizeList(`${config.product?.title || config.model} Listing`);
  let lastViewedId = '';
  function trackView(button) {
    const variant = selectedVariant();
    if (!variant || String(variant.id) === String(lastViewedId)) return;
    lastViewedId = variant.id;
    ecommerce('view_item', item(variant, viewList), button);
  }
  let buttonName = 'ADD TO CART';
  function captureAdd(form) {
    const data = new FormData(form);
    return { variantId: String(data.get('id') || ''), quantity: Number(data.get('quantity') || 1), button: buttonName };
  }
  function added(response, submission) {
    const lines = Array.isArray(response) ? response : response?.items || [response];
    lines.forEach(line => {
      if (!line || !mapping[line.sku]) return;
      const variant = config.product?.variants.find(entry => String(entry.id) === String(line.variant_id || line.id));
      if (!variant) return;
      if (!submission || String(variant.id) !== submission.variantId) return;
      // /cart/add may return the cart line's accumulated quantity, not this submission's delta.
      const productItem = item(variant, 'pdp', 1, submission.quantity);
      if (!productItem || !(productItem.quantity > 0)) return;
      // Ajax response amounts are authoritative; do not read a later UI selection.
      productItem.price = money(line.final_price ?? line.price ?? variant.price);
      productItem.discount = money(Math.max(0, Number(line.original_price ?? line.price ?? variant.price) - Number(line.final_price ?? line.price ?? variant.price)));
      ecommerce('add_to_cart', productItem, submission.button);
    });
  }
  function rememberLegacy(data, eventName, id = data?.[3], name = data?.[4]) {
    if (eventName !== 'select_item' || !mapping[data?.[0]]) return;
    remember(data[0].startsWith('T520-') ? 'openfit-air-2' : 'openrun-air-2', { id: id || '', name: name || '' });
  }
  window.nceXsGa4 = { added, captureAdd, rememberLegacy };

  function trackContent(element, type, name) {
    send('select_content', { content_type: type, content_name: name || '', button_name: text(element) || element.getAttribute('aria-label') || '' });
  }
  // Capture observes the action without stopping business handlers (including compare scroll links).
  document.addEventListener('click', event => {
    const target = event.target instanceof Element ? event.target : null;
    if (!target) return;
    const link = target.closest('a');
    if (config.home && link) {
      const slide = link.closest('.openfit-air-2-banner, .openrun-air-2-banner');
      if (slide) {
        const path = new URL(link.href, location.href).pathname;
        const button = path.includes('/products/') ? 'buy_now' : path.includes('/pages/') ? 'learn_more' : '';
        if (button) {
          const position = Number(slide.dataset.index);
          send('click_banner', { creative_slot: `banner_${position}`, position, creative_name: 'XSNCE_onsale', button_name: button });
          if (button === 'buy_now') remember(handleFromLink(link), { id: 'XSNCE_onsale', name: 'XSNCE_onsale' });
        }
      }
    }
    const commerceButton = target.closest('[data-nce-xs-item]');
    if ((config.infoPage || config.productPage) && commerceButton) {
      try {
        const data = JSON.parse(commerceButton.dataset.nceXsItem);
        ecommerce('select_item', item(data, commerceButton.dataset.nceXsList, data.index), text(commerceButton));
        remember(normalizeHandle(data.handle), commerceButton.dataset.nceXsList);
      } catch (_) { /* Missing catalog data must not break navigation. */ }
    } else if (link && !link.closest('.openfit-air-2-banner, .openrun-air-2-banner')) {
      // Existing global events retain ownership; only remember their list for new PDPs.
      const handle = handleFromLink(link);
      if (['openfit-air-2', 'openrun-air-2'].includes(handle)) {
        const data = link.querySelector('[data-product-data]') || link.closest('[data-product-data]');
        const parts = data?.dataset.productData?.split('::');
        remember(handle, { id: parts?.[3] || '', name: parts?.[4] || '' });
      }
    }
    if (config.infoPage) {
      const swatch = target.closest('[data-ofa2-ap-swatch]');
      // Existing labels are localized (including Japanese); analytics values must remain the brief's enums.
      if (swatch) trackContent(swatch, 'streamlined', ['blue', 'black', 'white'][Number(swatch.dataset.ofa2ApSwatch)]);
      const audio = target.closest('.ofa2-au__item-toggle');
      if (audio) {
        const index = Number(audio.closest('[data-slide-index]')?.dataset.slideIndex);
        trackContent(audio, 'sound', audio.dataset.contentName || ['sound', 'bass', 'customise'][index]);
      }
    }
    const compare = target.closest('.section-openfit-air-2-compare .compare-more-link, .section-openrun-air-2-compare .compare-more-link');
    if ((config.productPage || config.infoPage) && compare) send('compare_entry', { button_name: text(compare) });
    if (!config.productPage) return;
    const tab = target.closest('.product-tab-item');
    if (tab && event.isTrusted) send('select_content_category', { content_type: 'navigation_bar', button_name: tab.dataset.label || text(tab) });
    const add = target.closest('.btn--add-to-cart');
    if (add && !add.disabled) buttonName = text(add.querySelector('.btn__text')) || text(add);
    const color = target.closest('.product-right .single-option-radio label, .product-right .options-color-wrapper');
    const size = target.closest('.toggle-product-size-item');
    if (color || size) {
      const label = size
        ? (size.classList.contains('mini') ? 'Mini' : 'Standard')
        : (color.getAttribute('aria-label') || text(color.querySelector('.option-item')) || text(color));
      setTimeout(() => trackView(label), 100);
    }
    const design = target.closest('[data-xs-feature-link], .openmeet-2-everyday-life .od2el-btn');
    if (design) trackContent(design, 'product_design', design.dataset.contentName || text(design.closest('.openmeet-2-everyday-life')?.querySelector('.od2el-title')));
    const features = target.closest('.section-xs-additional-feartures .show-full');
    if (features) trackContent(features, 'product_features', text(features.closest('.section-xs-additional-feartures')?.querySelector('h2.title')));
  }, true);

  const seen = new Set();
  const exposureTargets = new Map();
  let observer;
  let frame = 0;
  function checkExposure() {
    frame = 0;
    exposureTargets.forEach((module, root) => {
      if (!root.isConnected || seen.has(module)) {
        observer?.unobserve(root);
        exposureTargets.delete(root);
        return;
      }
      const rect = root.getBoundingClientRect();
      if (!root.getClientRects().length || rect.height <= 0 || rect.width <= 0) return;
      if (rect.bottom < 0 || rect.bottom > window.innerHeight || rect.right <= 0 || rect.left >= window.innerWidth) return;
      if (getComputedStyle(root).visibility === 'hidden') return;
      seen.add(module);
      send('module_impression', { module });
      observer?.unobserve(root);
      exposureTargets.delete(root);
    });
  }
  function scheduleExposure() {
    if (!frame && exposureTargets.size) frame = requestAnimationFrame(checkExposure);
  }
  function watch(selector, module) {
    document.querySelectorAll(selector).forEach(root => {
      if (root.dataset.nceXsObserved || seen.has(module)) return;
      root.dataset.nceXsObserved = 'true';
      exposureTargets.set(root, module);
      observer?.observe(root);
    });
  }
  function observeModules() {
    if (config.infoPage) {
      const selectors = config.model === 'openfit-air-2' ? {
        selling_points: '.section-openfit-air-2-highlights', lightweight: '.section-openfit-air-2-lightness',
        streamlined: '.section-openfit-air-2-appearance', sound: '.section-openfit-air-2-audio',
        control: '.section-openfit-air-2-control', battery: '.section-openfit-air-2-battery', clear_calls: '.ofa2-calls'
      } : {
        selling_points: '.section-openrun-air-2-highlights', design: '.section-openrun-air-2-sellpoint-1',
        lightweight: '.section-openrun-air-2-sellpoint-2', IP67: '.ora2-sp34__weather',
        sound: '.section-openrun-air-2-sellpoint-5', battery: '.section-openrun-air-2-sellpoint-4', clear_calls: '.section-openrun-air-2-sellpoint-6'
      };
      Object.entries(selectors).forEach(([module, selector]) => watch(selector, module));
    }
    if (config.productPage || config.infoPage) {
      // Product-card row is the visible comparison entry; same module on PDP and OpenRun info.
      watch('.section-openfit-air-2-compare .compare_table .compare_row:first-child, .section-openrun-air-2-compare .compare_table .compare_row:first-child', 'product_compare');
    }
    scheduleExposure();
  }
  function init() {
    if (!config.productPage && !config.infoPage) return;
    if (config.productPage) {
      viewList = normalizeList(consumeSource()) || viewList;
      const variant = selectedVariant();
      if (variant) {
        lastViewedId = variant.id;
        ecommerce('view_item', item(variant, viewList));
      }
    }
    if ('IntersectionObserver' in window) {
      observer = new IntersectionObserver(scheduleExposure);
    }
    // Check actual bottom geometry: full visibility thresholds fail for modules taller than the viewport.
    // No injected marker or positioning change, so sticky/overflow layouts remain untouched.
    observeModules();
    window.addEventListener('scroll', scheduleExposure, { passive: true });
    window.addEventListener('resize', scheduleExposure);
    document.addEventListener('click', scheduleExposure);
    document.addEventListener('load', scheduleExposure, true);
    document.addEventListener('shopify:section:load', observeModules);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
